.form-box {
  margin: 20px;
}
.form-box label {
  width: 200px;
  display: inline-block;
}
.form-box ix-select {
  width: 400px;
}
